import React, { createContext, useContext } from "react";

const MainGlobalContext = createContext();

const MainGlobalProvider = ({ children, data }) => {
  return (
    <MainGlobalContext.Provider
      value={{
        galleryData: data?.mainGalleryImages,
        whyFeaturesData: data?.mainWhyList,
        opinionsData: data?.mainOpinionsList,
      }}
    >
      {children}
    </MainGlobalContext.Provider>
  );
};

const useMainGlobal = () => useContext(MainGlobalContext);
export { useMainGlobal };
export default MainGlobalProvider;
